import request from "../utils/request"

export function generateRectificationDraft(data) {
  return request({ url: "/office/rectification/ai-draft", method: "post", data, timeout: 90000 })
}

export function fetchRectificationBatches() {
  return request({ url: "/office/rectification/batches", method: "get" })
}

export function fetchRectificationItems(batchId) {
  return request({ url: `/office/rectification/batches/${batchId}/items`, method: "get" })
}

export function saveRectificationBatch(data) {
  return request({ url: "/office/rectification/batches", method: "post", data })
}

export function setRectificationCompleted(issueId, completed) {
  return request({ url: `/office/rectification/items/${issueId}/completion`, method: "patch", data: { completed } })
}

export function setRectificationStatus(issueId, status) {
  return request({ url: `/office/rectification/items/${issueId}/status`, method: "patch", data: { status } })
}

export function fetchRectificationAttachments(issueId) {
  return request({ url: `/office/rectification/issues/${issueId}/attachments`, method: "get" })
}

export function uploadRectificationAttachments(issueId, files, assetKind, note, onUploadProgress) {
  const data = new FormData()
  files.forEach(file => data.append("files", file))
  return request({
    url: `/office/rectification/issues/${issueId}/attachments`,
    method: "post",
    params: { assetKind, note },
    data,
    timeout: 180000,
    onUploadProgress
  })
}

export function removeRectificationAttachment(attachmentId) {
  return request({ url: `/office/rectification/attachments/${attachmentId}`, method: "delete" })
}
